export default __webpack_public_path__ + "media/images/twitter-social-b3d31e87635b8ababcaf5278b71a4e76.svg";